import Home from "../../../home/Home";
import LoginPage from "../../../login/LoginPage";

export const mainRoutes = [
  {
    text: "Home",
    path: "/",
    exact: true,
    element: <Home />,
  },
  {
    text: "Login",
    path: "/login",
    exact: true,
    element: <LoginPage />,
  },
];
